import styled from 'styled-components';

export const ProductImpactContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;

export const ProductImpactHeading = styled.h1`
  font-size: 17px;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  margin-bottom: 18px;

  @media (max-width: 720px) {
    font-size: 15px;
  }
`;

export const ProductImpactContainerOuter = styled.div`
  margin: 16px 0;
`;

export const ProductImpactDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 5px 9px;
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.5;
  }

  @media (max-width: 720px) {
    p {
      font-size: 12px;
    }
    margin: 2px;
    gap: 10px;
  }
`;
